import { FaUserDoctor, FaUser } from 'react-icons/fa6';
import LocationUsers from './LocationUsers';
import ResourceList from './ResourceList';
import { deactivateRoom, reactivateRoom, deactivateDoctor, reactivateDoctor } from '../utils/apiCalls';

export default function LocationCard({ location, clinicIsActive, token, onAddDoctor, onAddUser, onChange }) {

    return (
        <div key={location.location_id} className='border rounded p-4 space-y-2 bg-gray-50'>
            <h4 className="font-semibold">
                {location.location_name}
            </h4>
            {/* Rooms  */}
            <div className='grid grid-cols-2'> 
                <div className='flex flex-col space-y-3'>
                    <ResourceList title='rooms' disabled={!clinicIsActive} items={location.rooms.map(room => ({
                        id: room.room_id, name: room.room_name, is_active: room.is_active,
                        }))}
                        onDeactivate={async (id) => {
                            await deactivateRoom(id, token);
                            onChange();
                        }}
                        onReactivate={async (id) => {
                            await reactivateRoom(id, token);
                            onChange();
                        }}
                    />

                    {/* Doctors  */}
                    <ResourceList title='doctors' disabled={!clinicIsActive} items={location.doctors.map(doctor => ({
                        id: doctor.doctor_id, name: doctor.doctor_name, is_active: doctor.is_active,
                        }))}
                        onDeactivate={async (id) => {
                            await deactivateDoctor(id, token);
                            onChange();
                        }}
                        onReactivate={async (id) => {
                            await reactivateDoctor(id, token);
                            onChange();
                        }}
                    />

                    <LocationUsers locationId={location.location_id} token={token} onChange={onChange} />

                </div>

                {/* Add doctor, add user buttons  */}
                <div className='w-full sm:w-1/4 md:w-[15%] flex justify-center sm:justify-start align-center'>
                    <div className='flex flex-col space-y-3'>
                        <button onClick={() => onAddDoctor(location.location_id)} disabled={!clinicIsActive} className={`text-3xl rounded border-gray-300 p-3  ${clinicIsActive ? 'hover:bg-docpgrPurple30 text-docpgrPurple90' : 'cursor-not-allowed text-gray-400'}`} aria-label='Add Doctor'>
                            <span className='flex'> + <FaUserDoctor /> </span>
                        </button>
                        <button onClick={() => onAddUser(location.location_id)} disabled={!clinicIsActive} className={`text-3xl rounded border-gray-300 p-3  ${clinicIsActive ? 'hover:bg-docpgrPurple30 text-docpgrPurple90' : 'cursor-not-allowed text-gray-400'}`}   aria-label='Add User'>
                                <span className='flex'> + <FaUser /> </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}